import React, { useState } from 'react';
import axios from 'axios';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import HeaderTwo from '../common/header/HeaderTwo';
import { FaMapMarkerAlt, FaPhone, FaVideo, FaEnvelope, FaUser, FaPhoneAlt, FaCommentDots } from 'react-icons/fa';
import { API_URLS } from '../config/api';

const ContactLocaJoy = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: 'Je souhaite lancer mon premier projet',
        message: ''
    });
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMessage(null);

        try {
            const response = await axios.post(`${API_URLS.base}/contact`, formData);
            
            if (response.data.success) {
                setMessage({ type: 'success', text: 'Votre message a été envoyé avec succès ! Nous vous recontacterons sous 48h.' });
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: 'Je souhaite lancer mon premier projet',
                    message: ''
                });
            }
        } catch (error) {
            console.error('Erreur lors de l\'envoi du formulaire de contact:', error);
            setMessage({ type: 'error', text: 'Une erreur est survenue. Veuillez réessayer.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <SEO title="Contact - LocaJoy" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderTwo />
                
                {/* Hero Section */}
                <div className="contact-hero-section" style={{
                    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/banner/contact-hero.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    padding: '120px 0 80px',
                    marginTop: '80px'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="title" style={{ color: '#fff', fontSize: '48px', marginBottom: '20px' }}>
                                    Contactez LocaJoy
                                </h1>
                                <p style={{ color: '#fff', fontSize: '18px', lineHeight: '1.6' }}>
                                    Vous avez des questions ? Vous souhaitez nous contacter, écrivez-nous maintenant
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Cards Section */}
                <div className="section section-padding bg-color-light">
                    <div className="container">
                        <div className="row g-4">
                            {/* Nos adresses */}
                            <div className="col-lg-3 col-md-6">
                                <div className="contact-card" style={{
                                    backgroundColor: '#1f2937',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    height: '100%',
                                    color: '#fff',
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer'
                                }}>
                                    <div className="icon-wrapper" style={{
                                        width: '60px',
                                        height: '60px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 20px'
                                    }}>
                                        <FaMapMarkerAlt style={{ fontSize: '28px', color: '#fff' }} />
                                    </div>
                                    <h4 style={{ fontSize: '20px', marginBottom: '15px', fontWeight: '600' }}>
                                        Nos adresses
                                    </h4>
                                    <p style={{ fontSize: '14px', lineHeight: '1.6', opacity: '0.8' }}>
                                        Bureaux à Orléans<br />
                                        Déplacement France entière
                                    </p>
                                </div>
                            </div>

                            {/* Contact */}
                            <div className="col-lg-3 col-md-6">
                                <div className="contact-card" style={{
                                    backgroundColor: '#1f2937',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    height: '100%',
                                    color: '#fff',
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer'
                                }}>
                                    <div className="icon-wrapper" style={{
                                        width: '60px',
                                        height: '60px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 20px'
                                    }}>
                                        <FaPhone style={{ fontSize: '28px', color: '#fff' }} />
                                    </div>
                                    <h4 style={{ fontSize: '20px', marginBottom: '15px', fontWeight: '600' }}>
                                        Contact
                                    </h4>
                                    <p style={{ fontSize: '14px', lineHeight: '1.6', opacity: '0.8' }}>
                                        Écrivez-nous sur<br />
                                        whatsapp
                                    </p>
                                </div>
                            </div>

                            {/* Première visio */}
                            <div className="col-lg-3 col-md-6">
                                <div className="contact-card" style={{
                                    backgroundColor: '#1f2937',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    height: '100%',
                                    color: '#fff',
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer'
                                }}>
                                    <div className="icon-wrapper" style={{
                                        width: '60px',
                                        height: '60px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 20px'
                                    }}>
                                        <FaVideo style={{ fontSize: '28px', color: '#fff' }} />
                                    </div>
                                    <h4 style={{ fontSize: '20px', marginBottom: '15px', fontWeight: '600' }}>
                                        Première visio
                                    </h4>
                                    <p style={{ fontSize: '14px', lineHeight: '1.6', opacity: '0.8' }}>
                                        Réservez un call en<br />
                                        vision avec l'équipe<br />
                                        LocaJoy
                                    </p>
                                </div>
                            </div>

                            {/* Nous écrire */}
                            <div className="col-lg-3 col-md-6">
                                <div className="contact-card" style={{
                                    backgroundColor: '#1f2937',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    height: '100%',
                                    color: '#fff',
                                    transition: 'transform 0.3s ease',
                                    cursor: 'pointer'
                                }}>
                                    <div className="icon-wrapper" style={{
                                        width: '60px',
                                        height: '60px',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 20px'
                                    }}>
                                        <FaEnvelope style={{ fontSize: '28px', color: '#fff' }} />
                                    </div>
                                    <h4 style={{ fontSize: '20px', marginBottom: '15px', fontWeight: '600' }}>
                                        Nous écrire
                                    </h4>
                                    <p style={{ fontSize: '14px', lineHeight: '1.6', opacity: '0.8' }}>
                                        Un premier contact par<br />
                                        mail pour cerner vos<br />
                                        attentes
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form Section */}
                <div className="section section-padding">
                    <div className="container">
                        <div className="row align-items-center">
                            {/* Left Column - Map */}
                            <div className="col-lg-6 mb-5 mb-lg-0">
                                <div style={{
                                    backgroundColor: '#1f2937',
                                    borderRadius: '20px',
                                    padding: '60px 40px',
                                    textAlign: 'center',
                                    color: '#fff'
                                }}>
                                    <h3 style={{ fontSize: '28px', marginBottom: '10px', fontWeight: '600' }}>
                                        Plus de 750 logements gérés partout en France 🇫🇷
                                    </h3>
                                    <div style={{ marginTop: '40px' }}>
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/others/france-map.png"} 
                                            alt="Carte de France"
                                            style={{ maxWidth: '100%', height: 'auto' }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Right Column - Form */}
                            <div className="col-lg-6">
                                <div style={{ paddingLeft: '40px' }}>
                                    <h2 style={{ fontSize: '32px', marginBottom: '15px', fontWeight: '600' }}>
                                        Contactez LocaJoy maintenant
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '30px' }}>
                                        Vous avez un projet de location courte durée ou souhaitez en savoir plus sur notre service clé en main ?
                                    </p>
                                    <p style={{ fontSize: '16px', color: '#111827', marginBottom: '30px' }}>
                                        L'équipe LocaJoy est à votre disposition pour répondre à vos questions, vous conseiller et vous guider dans chaque étape.
                                    </p>

                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group mb-3">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                placeholder="Prénom et Nom"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    padding: '15px 20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb'
                                                }}
                                            />
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="E-mail"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        required
                                                        style={{
                                                            padding: '15px 20px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e5e7eb'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <input
                                                        type="tel"
                                                        name="phone"
                                                        className="form-control"
                                                        placeholder="Téléphone"
                                                        value={formData.phone}
                                                        onChange={handleChange}
                                                        required
                                                        style={{
                                                            padding: '15px 20px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e5e7eb'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group mb-3">
                                            <select
                                                name="subject"
                                                className="form-control"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    padding: '15px 20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb'
                                                }}
                                            >
                                                <option value="">Choisissez une option</option>
                                                <option value="Je souhaite lancer mon premier projet">Je souhaite lancer mon premier projet</option>
                                                <option value="J'ai déjà un bien et je veux le rentabiliser">J'ai déjà un bien et je veux le rentabiliser</option>
                                                <option value="Je veux développer une activité de sous-location">Je veux développer une activité de gestion locative</option>
                                                <option value="Autre">Autre</option>
                                            </select>
                                        </div>

                                        <div className="form-group mb-4">
                                            <textarea
                                                name="message"
                                                className="form-control"
                                                rows="5"
                                                placeholder="Votre message (optionnel)"
                                                value={formData.message}
                                                onChange={handleChange}
                                                style={{
                                                    padding: '15px 20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb'
                                                }}
                                            ></textarea>
                                        </div>

                                        {message && (
                                            <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                                                {message.text}
                                            </div>
                                        )}

                                        <button
                                            type="submit"
                                            className="axil-btn btn-fill-primary btn-large"
                                            disabled={submitting}
                                            style={{
                                                width: '100%',
                                                padding: '16px',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                borderRadius: '8px'
                                            }}
                                        >
                                            {submitting ? 'Envoi en cours...' : 'Envoyer'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
            </main>

            <style jsx>{`
                .contact-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
                }
            `}</style>
        </>
    );
};

export default ContactLocaJoy;
